import { useCallback, useEffect, useState } from "react";

import { arrayToPoint, pointToArray } from "../Features/MapComponents/geoUtils";
import { IMapSnapshotState } from "../Settings/settingsTypes";
import { IMapStateService } from "../Settings/serviceTypes";


const useLocalStorageMapState = (storeName: string): IMapStateService => {

    const reviver = (key: any, value: any): any => {
        if (key === 'centre')
            return value != null ? arrayToPoint(value) : null;

        return value;
    };

    const replacer = (key: any, value: any): any => {
        if (key === 'centre')
            return value != null ? pointToArray(value as L.LatLng) : null;

        return value;
    };

    const getFromStorage = (): IMapSnapshotState | null => {
        const rawItem = localStorage.getItem(storeName);
        return !!rawItem ? JSON.parse(rawItem, reviver) : null;
    };

    const [state, setState] = useState<IMapSnapshotState | null>(getFromStorage());

    const saveToStorage = useCallback(() => {
        if (state !== null)
            localStorage.setItem(storeName, JSON.stringify(state, replacer));
    }, [storeName, state]);

    useEffect(() => {

        const onVisibilityChange = async () => {

            const isAppActive = document.visibilityState === 'visible';
            if (isAppActive === false) {
                saveToStorage();
            }
        }

        document.addEventListener('visibilitychange', onVisibilityChange);
        document.addEventListener('beforeunload', saveToStorage);

        return () => {  //Unmount handler
            document.removeEventListener('beforeunload', saveToStorage)
            document.removeEventListener('visibilitychange', onVisibilityChange);
        }

    }, [saveToStorage])

    return { 
        state,
        setState
    };
    
};

export default useLocalStorageMapState;